import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'

class ContainerService {
  constructor() {
    this.$api = apiClient
  }

  getContainers(pagination, sorting, filters) {
    const query = transformIntoQuery(pagination, sorting, filters)
    return this.$api.get(`/admin/pack${query}`)
  }

  getContainer(id) {
    return this.$api.get(`/admin/pack/${id}`)
  }

  createContainer(payload) {
    return this.$api.post('/admin/pack', payload)
  }

  updateContainer(id, payload) {
    return this.$api.put(`/admin/pack/${id}`, payload)
  }

  deleteContainer(id) {
    return this.$api.delete(`/admin/pack/${id}`)
  }
}

export default new ContainerService()
